<template>
  <router-link v-if="to" :to="to" class="stat-card stat-card--link">
    <strong>{{ value }}</strong>
    <span>{{ label }}</span>
  </router-link>
  <article v-else class="stat-card">
    <strong>{{ value }}</strong>
    <span>{{ label }}</span>
  </article>
</template>

<script>
export default {
  name: 'CultureStatCard',
  props: {
    value: { type: [String, Number], required: true },
    label: { type: String, required: true },
    to: { type: [String, Object], default: null },
  },
};
</script>

<style scoped>
.stat-card {
  background: #141414;
  border: 1px solid #303030;
  border-radius: 10px;
  display: block;
  min-height: 120px;
  padding: 22px;
}

.stat-card--link {
  color: inherit;
  cursor: pointer;
  text-decoration: none;
  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.stat-card--link:hover,
.stat-card--link:focus-visible {
  border-color: #f0b13c;
  box-shadow: 0 8px 24px rgba(240, 177, 60, 0.16);
  outline: none;
  transform: translateY(-2px);
}

strong {
  color: #f0b13c;
  display: block;
  font-family: "Oswald", sans-serif;
  font-size: 2rem;
  line-height: 1;
  margin-bottom: 10px;
}

span {
  color: #d2d2d2;
  font-size: .88rem;
  font-weight: 700;
  text-transform: uppercase;
}
</style>
